<div class="relative max-sm:pt-32">
  @if (scrollableTabs) {
    <div
      class="absolute bg-gradient-to-r from-grey-light-concrete from-60% -left-2 -top-1 pl-5 pr-10 transition"
      [ngClass]="{ 'opacity-0 -z-10': !showScrollLeft }"
    >
      <button class="btn-icon ml-0.5" tooltip="Scroll Left" (click)="scrollTabs('left')">
        <ion-icon name="chevron-back-outline" class="size-4"></ion-icon>
      </button>
    </div>
  }

  <ul
    class="nav-tabs flex flex-row list-none max-sm:fixed max-sm:-top-2 max-sm:z-10 max-sm:bg-grey-light-concrete max-sm:border-b max-sm:border-grey-mid/30 max-sm:w-full max-sm:py-2 max-sm:mx-0"
    [ngClass]="{ 'overflow-x-scroll snap-x scroll-smooth scroll lg:w-[calc(100dvw-460px)]': scrollableTabs }"
    #tabList
    (scroll)="scrollTabs('scroll')"
  >
    @for (item of items; track item.title) {
      <li class="nav-item">
        <a
          [routerLink]="item.routerLink"
          class="nav-link block font-medium rounded text-base leading-tight border-x-0 border-t-0 border-transparent px-3 py-2 hover:border-transparent mr-2 whitespace-nowrap"
          id="{{ item.id }}"
          [ngClass]="
            item.activeForRouterLinks?.includes((currentRoute$ | async)?.routeConfig?.path) ||
            [item.routerLink].includes(currentUrl$ | async)
              ? 'bg-primary text-white active-tab'
              : 'text-grey-mid hover:bg-grey-concrete hover:text-black'
          "
        >
          {{ item.title }}
        </a>
      </li>
    }
  </ul>

  @if (scrollableTabs) {
    <div
      class="absolute bg-gradient-to-l from-grey-light-concrete from-75% right-1 lg:-right-4 -top-1 pr-2 pl-10 transition"
      [ngClass]="{ 'opacity-0 -z-10 ': !showScrollRight }"
    >
      <button id="scroll-right-btn" class="btn-icon" tooltip="Scroll Right" (click)="scrollTabs('right')">
        <ion-icon name="chevron-forward-outline" class="size-4"></ion-icon>
      </button>
    </div>
  }
</div>
